var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 19.1667V14.4445H5.41665V12.3611H3.33331V7.63889H5.41665V5.55554H3.33331V0.833328H8.88885V5.55554H6.80552V7.63889H8.88885V9.30556H11.9444V7.63889H17.5V12.3611H11.9444V10.6944H8.88885V12.3611H6.80552V14.4445H8.88885V19.1667H3.33331ZM4.72219 17.7778H7.49998V15.8333H4.72219V17.7778ZM4.72219 10.9722H7.49998V9.02777H4.72219V10.9722ZM13.3333 10.9722H16.1111V9.02777H13.3333V10.9722ZM4.72219 4.16666H7.49998V2.2222H4.72219V4.16666Z",
    fill: "#90A4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtl);
export default __webpack_public_path__ + "static/media/etl.40a36ed69941535c95c1d26cefad967d.svg";
export { ForwardRef as ReactComponent };